import { createApi } from '@reduxjs/toolkit/query/react';

import { CollectionDetails, CollectionNode } from '../types/collection-types';
import { baseQueryWithErrorHandling } from './baseQuery';

export const collectionsApiClient = createApi({
  reducerPath: 'collectionsApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['Collections'] as const,
  endpoints: (builder) => ({
    getCollectionList: builder.query<CollectionDetails[], string>({
      query: (matterId) => `api/matters/${matterId}/collections/`,
      providesTags: (result, error, matter_id) => [
        { type: 'Collections', id: matter_id },
      ],
    }),
    getCollectionTree: builder.query<CollectionNode, string>({
      query: (matterId) => `api/matters/${matterId}/collections/tree/`,
      providesTags: (result, error, matter_id) => [
        { type: 'Collections', id: matter_id },
      ],
    }),
    createChildCollection: builder.mutation<
      CollectionNode,
      { matterId: string; parentId: string; name: string }
    >({
      query: ({ matterId, parentId, name }) => ({
        url: `/api/matters/${matterId}/collections/${parentId}/create_child/`,
        method: 'POST',
        body: { name },
      }),
      invalidatesTags: (result, error, { matterId }) => [
        { type: 'Collections', id: matterId },
      ],
    }),
    updateCollection: builder.mutation<
      CollectionNode,
      { matterId: string; collectionId: string; name: string }
    >({
      query: ({ matterId, collectionId, name }) => ({
        url: `/api/matters/${matterId}/collections/${collectionId}/`,
        method: 'PUT',
        body: { name },
      }),
      invalidatesTags: (result, error, { matterId }) => [
        { type: 'Collections', id: matterId },
      ],
    }),
    destroyCollection: builder.mutation<
      void,
      { matterId: string; collectionId: string }
    >({
      query: ({ matterId, collectionId }) => ({
        url: `/api/matters/${matterId}/collections/${collectionId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { matterId }) => [
        { type: 'Collections', id: matterId },
      ],
    }),
  }),
});

export const {
  useGetCollectionListQuery,
  useGetCollectionTreeQuery,
  useCreateChildCollectionMutation,
  useUpdateCollectionMutation,
  useDestroyCollectionMutation,
} = collectionsApiClient;
